export function getNameIntials(name) {
  const spilitName = name.toUpperCase().split(" ");

  if (spilitName.length > 1) {
    return spilitName[0][0] + spilitName[1][0];
  }

  return spilitName[0][0];
}

export function transformToArr(snapVal) {
  return snapVal ? Object.keys(snapVal) : [];
}
export function transformToArrWithid(snapVal) {
  return snapVal
    ? Object.keys(snapVal).map((roomId) => {
        return { ...snapVal[roomId], id: roomId };
      })
    : [];
}

export async function getUserUpdate(userId, keyToUpdate, value, db) {
  const updates = {};

  updates[`/profiles/${userId}/${keyToUpdate}`] = value;

  const getMsgs = db
    .ref("/messages")
    .orderByChild("author/uid")
    .equalTo(userId)
    .once("value");

  const getRooms = db
    .ref("/rooms")
    .orderByChild("lastMessage/author/uid")
    .equalTo(userId)
    .once("value");

  const [mSnap, rSnap] = await Promise.all([getMsgs, getRooms]);

  mSnap.forEach((msgSnap) => {
    updates[`/messages/${msgSnap.key}/author/${keyToUpdate}`] = value;
  });

  rSnap.forEach((roomSnap) => {
    updates[`/rooms/${roomSnap.key}/lastMessage/author/${keyToUpdate}`] = value;
  });
  return updates;
}
